module.exports = __webpack_public_path__ + "static/media/benemite.b03afa96.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/aranha_roja_tomate/preventiva/benemite.png
// module id = 2384
// module chunks = 3